/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { CssClassName } from '~/util/Css';

/**
 * Exports
*/

/**
 * 
 */
export function Message(props) {
  return (
    <Fragment>
      {
        <div className={ CssClassName([ 'msg', props.className ]) } role='alert'>
          {
            props.title &&
              <p className='font-bold'>{ props.title }</p>
          }
          {
            props.children
          }
          <span className='absolute top-0 bottom-0 right-0 px-4 py-3' onClick={ props.onClose }>
            <svg className='fill-current h-6 w-6' role='button' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' data-close>
              <title>Close</title>
              <path d='M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z'/>
            </svg>
          </span>
        </div>
      }
    </Fragment>
  );
}

Message.propTypes = {
  title: PropTypes.string,
  className: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
  onClose: PropTypes.func
};